<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row mt-0 content-block-head">
      <div class="col p-2">
        <h4>Documents for {{this.vehicle.registration}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button class='btn btn-block btn-success' (click)='openModal("documentUploadModal")'>Upload Document</button>
      </div>
      <app-image-view-modal [image]='this.image'></app-image-view-modal>
      <app-document-upload-modal [vehicleId]='this.vehicleId'></app-document-upload-modal>
    </div>

    <div class="row">
      <div class="col">
        <app-grid
          entity='documents'
          [filters]='this.filters'
          [columns]='this.columns'
          [buttons]='this.buttons'
          [searchFilters]='this.searchFilters'
          [searchFields]='this.searchFields'
          >
        </app-grid>
      </div>
    </div>
  </div>
</div>
